import { useOrgLogos } from 'components/ThemeProvider';

const POS = {
  'top-right':    { top: 16,    right: 20 },
  'bottom-right': { bottom: 16, right: 20 },
  'top-left':     { top: 16,    left: 'calc(219px + 20px)' },
  'bottom-left':  { bottom: 16, left: 'calc(219px + 20px)' },
};

const OrgLogoWatermark = ({
  size = 'clamp(90px, 11vw, 170px)',
  opacity = 0.9,
  corners = ['top-right', 'bottom-right'],
  zIndex = 0,
}) => {
  const { logoTopUrl, logoBottomUrl } = useOrgLogos();
  return (
    <>
      {corners.map((c) => {
        const src = c.startsWith('top') ? logoTopUrl : logoBottomUrl;
        if (!src) return null;
        return (
          <img key={c} src={src} alt="" aria-hidden="true"
            style={{
              position: 'fixed', ...POS[c],
              width: size, maxHeight: size, objectFit: 'contain',
              opacity, pointerEvents: 'none', zIndex,
            }} />
        );
      })}
    </>
  );
};
export default OrgLogoWatermark;